export default __webpack_public_path__ + "static/char-v-58-ja-4e9d01dec1e335150d7e5af64c0af140.mp4";